import React, { useState, useEffect } from "react";
import { Tabs, ConfigProvider } from "antd";
import ListTreatedDevice from "./tab-component/ListTreatedDevice";
import ListTreatedReports from "./tab-component/ListTreatedReports";
import AllCertificates from "./tab-component/AllCertificates";

const AdminManageDevice = () => {
  const items = [
    {
      key: "1",
      label: `List Device`,
      children: <ListTreatedReports />,
    },
    // {
    //   key: "2",
    //   label: `Add Admin`,
    //   children: <RegisterUser />,
    // },
    {
      key: "2",
      label: `Approved Device Application`,
      children: <ListTreatedDevice />,
    },
    {
      key: "3",
      label: `Issued Certificate`,
      children: <AllCertificates/>,
    },
  ];
  const [activeTab, setActiveTab] = useState(items[0].key);
  const [activeKey, setActiveKey] = useState(
    localStorage.getItem("activeTab") || "1"
  );
  const [visitedTabs, setVisitedTabs] = useState(() => {
    const storedKey = localStorage.getItem("activeTab");
    return storedKey ? [storedKey] : ["1"];
  });
  const handleTabChange = (key) => {
    setActiveTab(key); // Update active tab key when tab changes
  };

  const tabBarStyle = {
    width: '100%',
    textAlign: 'center',
  };

  const onTabClick = (key) => {
    localStorage.setItem("activeTab", key);
    setActiveKey(key);
  };

  useEffect(() => {
    const storedKey = localStorage.getItem("activeTab");
    if (storedKey) {
      setActiveKey(storedKey);
    }
  }, []);
  // return <Tabs defaultActiveKey="1" items={items} onChange={onChange} />;
  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            colorPrimary: "#1A472B",
            colorPrimaryHover: "#464947",
            colorPrimaryActive: "#464947",
            fontSize: 15,
          },
        },
      }}
    >
      <Tabs
      activeKey={activeTab}
      defaultActiveKey={visitedTabs[0]}
      onChange={handleTabChange}
      onTabClick={onTabClick}
      tabPosition="top"
      tabBarStyle={tabBarStyle}
      renderTabBar={(props, DefaultTabBar) => (
        <DefaultTabBar {...props}>
          {React.Children.map(props.children, (child, index) =>
            React.cloneElement(child, {
              visible: visitedTabs.includes(child.key),
            })
          )}
        </DefaultTabBar>
      )}
    >
      {items.map((item) => (
        <Tabs.TabPane key={item.key} tab={item.label}>
          {activeTab === item.key && item.children}
        </Tabs.TabPane>
      ))}
    </Tabs>
    </ConfigProvider>
  );
};

export default AdminManageDevice;
